<template>
    <div :class="computedSize">
        <div class="card card-small mb-4">
            <div class="card-header pb-0 mb-3 " :class="title? '': 'd-none'">
                <h6 class="m-0 text-muted">{{title}}</h6>
            </div>
            <div class="card-body text-shuttle-gray" :class="fullBody ? 'p-0 ': '' ">
                <slot ></slot>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "wCard",
        props: {
            title: {
                required: false,
                type: String,
            },
            size: {
                required: true,
                type: String | Number,
                validator: function (value) {
                    // The value must match one of these strings
                    return ['20', '25', '30', '50', '75', '100', '110'].indexOf(value.toString()) !== -1
                }
            },
            fullBody: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        computed: {
            computedSize: function () {
                switch (this.size.toString()) {
                    case '20':
                        return 'col-12 col-md-6 col-lg-2 col-xl-2';
                    case '25':
                        return 'col-12 col-md-12 col-lg-3';
                    case '30':
                        return 'col-12 col-md-12 col-lg-4 col-xl-3';
                    case '50':
                        return 'col-12 col-md-12 col-lg-6';
                    case '70':
                        return 'col-12 col-md-12 col-lg-8 col-xl-9';
                    case '75':
                        return 'col-12 col-md-12 col-lg-9';
                    case '100':
                        return 'col-12';
                    default:
                        //console.error("numero incorrecto en la prop size");
                         return 'col-13';
                }
            }

        }

    }
</script>

<style scoped lang="scss">

</style>